import { createAction, props } from '@ngrx/store';
import type {
  InputFile,
  RemoveFile,
} from '@shared/components/uploader/interfaces/files.interface';
import type { AssetType } from '@graphql/default/types';

const scoped = (templateString: TemplateStringsArray) =>
  `[UPLOADER] ${templateString[0]}`;
export const toggleViewUploader = createAction(scoped`toggle view uploader`);
export const clearUploaderAfterLogout = createAction(scoped`clear uploader`);
export const addUploadFiles = createAction(
  scoped`add upload files`,
  props<{ files: InputFile[] }>(),
);
export const addUploadFilesSuccess = createAction(
  scoped`add upload files success`,
  props<{ files: InputFile[]; errorFiles: InputFile[] }>(),
);
export const addErrorFiles = createAction(
  scoped`add error files`,
  props<{ files: InputFile[] }>(),
);
export const destroyUploaderComponent = createAction(
  scoped`uploader component destroyed`,
);
export const setUploaderLoaded = createAction(scoped`uploader loaded`);
export const getUploadingFilesFromLocalStorage = createAction(
  scoped`get previous session uploading files from local storage`,
);
export const getProcessingFilesFromLocalStorage = createAction(
  scoped`get previous session processing files from local storage`,
);
export const setFilesToLocalStorage = createAction(
  scoped`set previous session uploading files to local storage`,
);
export const setProcessingFilesToLocalStorage = createAction(
  scoped`set previous session processing files to local storage`,
);
export const addPreviousSessionProcessingFiles = createAction(
  scoped`add previous session processing files from local storage`,
  props<{ files: InputFile[] }>(),
);
export const addPreviousSessionUploadingFiles = createAction(
  scoped`add previous session uploading files from local storage`,
  props<{ files: InputFile[] }>(),
);
export const setCurrentUploadId = createAction(
  scoped`set current upload id`,
  props<{ uploadId: string | null }>(),
);
export const updateUploadProgress = createAction(
  scoped`set upload progress of uploading file`,
  props<{ progress: number | null }>(),
);
export const updateUploadRemainingTime = createAction(
  scoped`set remaining time of uploading file`,
  props<{ remainingTime: number | null }>(),
);
export const startUploadNewFile = createAction(scoped`start upload new file`);
export const fileUploadSuccess = createAction(
  scoped`file upload success`,
  props<{ uploadId: string }>(),
);
export const chunkUploadSuccess = createAction(
  scoped`file chunk upload success`,
  props<{
    uploadId: string;
    chunkNumber: number;
    remainingTime: number;
    isCompleted: boolean;
  }>(),
);
export const chunkUploadFailure = createAction(
  scoped`file chunk upload failure`,
  props<{ uploadId: string; error: string }>(),
);
export const removeFile = createAction(
  scoped`remove file from uploading list`,
  props<{ input: RemoveFile }>(),
);
export const removeFileSuccess = createAction(scoped`remove file success`);
export const preventUploadingProcess = createAction(
  scoped`prevent uploading process`,
);
export const goToAssignMaterial = createAction(
  scoped`go to assign material`,
  props<{ uploadId: string }>(),
);
export const navigateToAssignMaterials = createAction(
  scoped`go to assign materials`,
);
export const clearUploaderState = createAction(scoped`clear uploader state`);
export const clearUploaderStateSuccess = createAction(
  scoped`clear uploader state success`,
);
export const assetProcessingSuccess = createAction(
  scoped`processing success`,
  props<{
    files: InputFile[];
    createdAssets: Record<string, { assetId: string; assetType: AssetType }>;
  }>(),
);
export const assetProcessingRequestFailure = createAction(
  scoped`processing failure`,
  props<{ error: string }>(),
);
export const updateProcessingFilesStatusesByProcessingResult = createAction(
  '[Uploader] Update Files Status',
  props<{ files: InputFile[] }>(),
);
export const setCreatedAssets = createAction(
  '[Uploader] Set Created Assets',
  props<{
    assets: Record<string, { assetId: string; assetType: AssetType }>;
  }>(),
);
